class ChangeSignature {
    constructor(actualSig, newSig, newSigRep, userNumber) {
        this.actualSig = actualSig;
        this.newSig = newSig;
        this.newSigRep = newSigRep;
        this.userNumber = userNumber;
    }
}

export default ChangeSignature;